module.exports = __webpack_public_path__ + "img/about-illustration-mobile@3x.15f5d472.png";